import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { openModalEmail, openModalQuotationDateWarning } from '../../../actions/comparisonActions';
import { formatURL, isMobile, formatPrice, convertDate, getMaxParcel, getDestinationBySlug } from '../../../utils';

import './ComparisonBar.css';

import PixDiscountTag from '../../search/plans_table/PixDiscountTag';

class PlanInfo extends Component {
  constructor(props) {
    super(props);
    this.goToPurchasePage = this.goToPurchasePage.bind(this);
  }

  goToPurchasePage(e) {
    e.onClick(e);
  }

  render() {
    const link = formatURL(
      this.props.match.params,
      `/pedido/${this.props.plan.code}/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}`
    );
    const purchaseBtnClass = this.props.disabled ? 'desligado' : '';

    return (
      <li>
        <div className="flex box-plano-new">
          <span className="name-plan">{this.props.plan.name}</span>
          <span className="span-small">
            Faixa etária: {this.props.plan.child.min_age} a {this.props.plan.elder.max_age} anos
          </span>

          <a href={this.props.plan.terms_url} target="_blank" rel="noopener noreferrer" className="link-cond">
            Ver condições gerais
          </a>

          <div className="price-mobile">
            {this.props.plan.price_with_coupon_discount > 0 ? (
              <p className="first-price">
                <s>R$ {formatPrice(this.props.plan.adult.price)}</s>
              </p>
            ) : (
              <p className="first-price"> </p>
            )}
            <p className="real-price">
              <strong>
                R$
                {this.props.plan.price_with_coupon_discount > 0 ? (
                  <span> {formatPrice(this.props.plan.price_with_coupon_discount)} </span>
                ) : (
                  <span> {formatPrice(this.props.plan.adult && this.props.plan.adult.price)} </span>
                )}
              </strong>
              {getMaxParcel(this.props.plan.adult && this.props.plan.adult.price)}x sem juros
            </p>
            <p className="price-pix">
              <strong>R$ {formatPrice(this.props.plan.price_with_discount)}</strong> <PixDiscountTag isMobile={isMobile()} />
            </p>
          </div>
        </div>
        <Link to={link} onClick={this.goToPurchasePage} className={`comprar-plano flex ${purchaseBtnClass}`} title="" />
      </li>
    );
  }
}

class ComparisonBar extends Component {
  constructor(props) {
    super(props);



    this.openModalEmail = this.props.openModalEmail.bind(this);
    const begin_date = this.props.match.params.begin_date.split('-'),
    end_date = this.props.match.params.end_date.split('-');

    let destination;
    if(this.props.destinations.filter((dest) => dest.slug === this.props.match.params.destination)[0] !== undefined) {
      destination = this.props.destinations.filter((dest) => dest.slug === this.props.match.params.destination)[0].name;
    }
    else {
      destination = getDestinationBySlug(this.props.match.params.destination);
    }

    this.destination = destination;

    this.begin_date = `${begin_date[2]}/${begin_date[1]}/${begin_date[0]}`;
    this.end_date = `${end_date[2]}/${end_date[1]}/${end_date[0]}`;
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    const bar = document.querySelector('.comparacao-planos');
    const list = document.querySelector('.area-lista-comparacao');
    if (list && bar)
      window.addEventListener('scroll', () => {
        if (window.scrollY > 120) {
          bar.classList.add('fixedd');
          list.style.marginTop = '250px';
        } else {
          bar.classList.remove('fixedd');
          list.style.marginTop = '5px';
        }
      });
  }

  goBack() {
    this.props.history.go(-1);
  }

  render() {
    const termsUrl = [];

    const providers = this.props.providers;

    const plan_comparison = [...this.props.plans].reverse();

    plan_comparison.forEach((plan) => {
      const item = providers.filter((provider) => provider.name === plan.provider_name);
      if (item.terms_url) termsUrl.push(item.terms_url);
      if (item[0]) termsUrl.push(item[0].terms_url);
    });

    return (
      <section className="comparacao-planos">
        <div className="component">
          <a onClick={this.goBack} className="link-back-search">
            <img src="/assets/images/icons/arrowLeft.svg" alt="voltar" />
            <span>Voltar à pesquisa</span>
          </a>
          <div className="header-compare">
            <div className="header-info-comparacao">
              <h3>Compare os planos:</h3>
              <div className="new-box-details-comparation">
                <p className="p-green">Você pesquisou por:</p>
                <p className="p-principal">{this.destination}</p>
                <span className="span-small">
                  <span>
                    {convertDate(this.props.match.params.begin_date)} - {convertDate(this.props.match.params.end_date)}
                  </span>
                </span>
              </div>

              <button onClick={this.props.openModalEmail} className="btn-send-comparison-email">
                <img src="/assets/images/icons/plane.svg" />
                <span>Enviar comparação por e-mail</span>
              </button>
            </div>
            <div className="">
              {plan_comparison && (
                <ul className="lista-compara">
                  {plan_comparison[3] && !isMobile() && (
                    <PlanInfo
                      openModalQuotationDateWarning={this.props.openModalQuotationDateWarning}
                      plan={plan_comparison[3]}
                      terms_url={termsUrl[3]}
                      key={4}
                      match={this.props.match}
                      isUpsell={String(plan_comparison[3].code) === this.props.upsellUpgrade}
                    />
                  )}
                  {plan_comparison[2] && !isMobile() && (
                    <PlanInfo
                      openModalQuotationDateWarning={this.props.openModalQuotationDateWarning}
                      plan={plan_comparison[2]}
                      terms_url={termsUrl[2]}
                      key={3}
                      match={this.props.match}
                      isUpsell={String(plan_comparison[2].code) === this.props.upsellUpgrade}
                    />
                  )}
                  {plan_comparison[1] && (
                    <PlanInfo
                      openModalQuotationDateWarning={this.props.openModalQuotationDateWarning}
                      plan={plan_comparison[1]}
                      terms_url={termsUrl[1]}
                      key={2}
                      match={this.props.match}
                      isUpsell={String(plan_comparison[1].code) === this.props.upsellUpgrade}
                    />
                  )}
                  {plan_comparison[0] && (
                    <PlanInfo
                      openModalQuotationDateWarning={this.props.openModalQuotationDateWarning}
                      plan={plan_comparison[0]}
                      terms_url={termsUrl[0]}
                      key={1}
                      match={this.props.match}
                      isUpsell={String(plan_comparison[0].code) === this.props.upsellUpgrade}
                    />
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plans: state.search.plans,
      userDetails: state.comparison.userDetails,
      destinations: state.global.destinations,
      providers: state.global.providers,
      upsellUpgrade: state.purchase.upsellUpgrade,
    }),
    {
      openModalEmail,
      openModalQuotationDateWarning,
    }
  )(ComparisonBar)
);



// WEBPACK FOOTER //
// ./src/components/comparison/comparison_bar/ComparisonBar.jsx